import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";
import { useAppliedByMember } from "./useAppliedByMember";
import styles from "./WorkAppliedByCell.module.scss";

/** The organization member who applied the work; nothing until members load. */
export const WorkAppliedBy = ({ userId }: { userId: number }) => {
    const appliedBy = useAppliedByMember(userId);

    if (!appliedBy) {
        return EMPTY_CELL_VALUE;
    }

    const { member, name } = appliedBy;

    return (
        <div className={styles.container}>
            {member && <UserAvatar user={member.user} size="xs" aria-hidden />}
            <span className={styles.name}>{name}</span>
        </div>
    );
};

export const WorkAppliedByCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        number | null
    >) => {
        if (
            row.original.rowType !== "work" ||
            row.original.createdByUserId == null
        ) {
            return EMPTY_CELL_VALUE;
        }

        return <WorkAppliedBy userId={row.original.createdByUserId} />;
    },
);

WorkAppliedByCell.displayName = "WorkAppliedByCell";
